import React from "react";
import AboutComponent from "../porftfolio-components/AboutComponent";
import TopBgComponent from "../porftfolio-components/TopBgComponent";
import { motion } from "framer-motion";
import WebComponent from "../porftfolio-components/WebComponent";
import SiteListComponent from "../porftfolio-components/SiteListComponent";
import FooterOneComponent from "../components/FooterOneComponent";
import FooterComponent from "../components/FooterComponent";
import AppComponent from "../porftfolio-components/AppComponent";
import AppListComponent from "../porftfolio-components/AppListComponent";
function PortfolioPage() {
  return (
    <motion.div exit={{ opacity: 0, backgroundColor: "#63FFCD" }}>
      <TopBgComponent />
      <AboutComponent />
      <WebComponent />
      <SiteListComponent />
      <AppComponent />
      <AppListComponent />
      <FooterOneComponent />
      <FooterComponent />
    </motion.div>
  );
}

export default PortfolioPage;
